import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient) { }

  exchangeCodeForToken(code: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const codeVerifier = localStorage.getItem('pkce_code_verifier');
    
    const body = new HttpParams()
      .set('client_id', environment.msalConfig.auth.clientId)
      .set('scope', 'openid profile email api://api.internal.baaskit.com/cl.dashboard.read.user')
      .set('code', code)
      .set('redirect_uri', AuthService.getTokenRedirectUri())
      .set('grant_type', 'authorization_code')
      .set('code_verifier', codeVerifier || '');

    return this.httpClient.post(
      environment.msalConfig.auth.authority.replace('/v2.0', '/oauth2/v2.0/token'),
      body.toString(),
      { headers }
    );
  }

  static getLoginAzureUrl() {
    const codeVerifier = AuthService.generateCodeVerifier();
    const codeChallenge = AuthService.generateCodeChallenge(codeVerifier);
    
    // Store code verifier for token exchange
    localStorage.setItem('pkce_code_verifier', codeVerifier);
    
    const loginParams = new URLSearchParams([
      ["client_id", environment.msalConfig.auth.clientId],
      ["response_type", "code"],
      ["redirect_uri", AuthService.getTokenRedirectUri()],
      ["response_mode", "query"],
      ["scope", "openid profile email"],
      ["code_challenge", codeChallenge],
      ["code_challenge_method", "plain"],
      ["prompt", "login"]
    ]).toString();

    return `${environment.msalConfig.auth.authority.replace('/v2.0', '/oauth2/v2.0/authorize')}?${loginParams}`;
  }

  private static generateCodeVerifier(): string {
    // Generate 43-128 character string as per RFC 7636
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    for (let i = 0; i < 128; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  private static generateCodeChallenge(verifier: string): string {
    // For simplicity, use plain method (verifier = challenge)
    return verifier;
  }

  static getTokenRedirectUri() {
    return `${window.location.protocol}//${window.location.host}/auth`;
  }

  logout() {
    localStorage.removeItem('auth.access_token');
    localStorage.removeItem('auth.expires_on');
    localStorage.removeItem('auth.user_info');
    window.location.href = AuthService.getLoginAzureUrl();
  }
}